<template>
  <div class="page">
    <video class="video" src="../assets/video/dalibao0808.mp4?v=2024088" poster="../assets/images/intro/poster.png?v=20240811" controls></video>
    <div class="title">980礼包使用说明</div>
    <div class="title2">980礼包内包含的产品</div>
    <div class="p">980礼包内里面包含了：蜂计划季卡，蜂竞技季卡，第十赛季官方指导手册，主题键盘，小巨蛋麦克，使用场景和使用说明。</div>
    <div class="title2">开箱指导</div>
    <div class="p">打开箱子后，可以看到盒子盖上附有拼词之星下载地址和激活卡，扫码下载“拼词之星APP”后，注册登录并完善个人信息，使用拼词之星内的扫一扫，扫码盒盖上粘贴的蜂竞技激活卡和纸质词库后面粘贴的蜂计划激活卡，提示已开通后，即可正常使用：电子词库，蜂计划，蜂竞技。    </div>
    <div class="title2">硬件设备连接蓝牙    </div>
    <div class="p">1.小巨蛋麦克：长按第一个开机按钮，开机后可以直接连接蓝牙，打开手机或者ipad的蓝牙，找到“SpellingStarMic”的这个蓝牙名称进行连接，如果未显示蓝牙，请长按中间的音符按钮连接蓝牙，短按是音效切换，上下键可以调节音量大小。    </div>
    <div class="img">
      <img src="../assets/images/intro/6991.png?v=20240805" alt="">
    </div>
    <div class="p">2.主题键盘：拿到键盘后，将键盘右上角的“ON/OFF”按钮往左划到“ON”，可以看到提升灯亮起，然后同时按住左下角的小蜜蜂按键和按键C，即可开启蓝牙，打开手机或者ipad的蓝牙，找到“SpellingStarKBD”的这个蓝牙名称进行连接。    </div>
    <div class="img">
      <img src="../assets/images/intro/6992.png?v=20240805" alt="">
    </div>
    <div class="title2">键盘按键使用说明    </div>
    <div class="p p1">
      空格键：语音问答<br/>
      START：开始/提交<br/>
      READY+？（先按READY再按?)：准备<br/>
      PASS:跳过当前单词<br/>
      RESPONDER+Z(先按RESPONDER再按Z）：抢答
    </div>
    <div class="img">
      <img src="../assets/images/intro/6993.png?v=20240805" alt="">
    </div>
    <div class="img">
      <img src="../assets/images/intro/6994.png?v=20240805" alt="">
    </div>

    <div class="title">拼词之星使用说明</div>
    <div class="title2">蜂词库使用说明</div>
    <div class="p">1、点击拼词之星首页蜂词库进入词库首页</div>
    <div class="img">
      <img class="img1" src="../assets/images/intro/pczx1.png?v=20240805" alt="">
    </div>
    <div class="img">
      <img class="img1" src="../assets/images/intro/pczx2.png?v=20240805" alt="">
    </div>
    <div class="p">2、词库目前提供了个人赛冠军词库和团体赛冠军词库</div>
    <div class="p">3、个人赛冠军词库点击会显示各个组别词库并包含词源词库和挑战词库</div>
    <div class="img">
      <img class="img1" src="../assets/images/intro/pczx5.png?v=20240805" alt="">
    </div>
    <div class="p">4、团体赛冠军词库点击会显示各个组别词库并包含词源词库</div>
    <div class="img">
      <img class="img1" src="../assets/images/intro/pczx4.png?v=20240805" alt="">
    </div>
    <div class="p">5、点击词库后进入单词列表，可以查看本词库的核心词汇</div>
    <div class="img">
      <img class="img1" src="../assets/images/intro/pczx3.png?v=20240805" alt="">
    </div>
    <div class="p">6、点击单词进入单词详情，可以点击单词、定义、例句收听到各自的发音。</div>
    <div class="img">
      <img class="img1" src="../assets/images/intro/pczx7.png?v=20240805" alt="">
    </div>




    <div class="title2">蜂计划使用说明</div>
    <div class="p">1、点击拼词之星首页蜂计划进入蜂计划首页</div>
    <div class="p">2、蜂计划首页顶部菜单分为“我的生词本”、“蜂计划天梯榜”、“我的小蜂巢”，中间部分卡片为最新创建的计划内容，底部为已创建的蜂计划内容</div>
    <div class="img">
      <img class="img1" src="../assets/images/intro/pczx6.png?v=20240805" alt="">
    </div>
    <div class="p">3、我的生词本展现的是在计划中打卡答错的单词会记录到我的生词本，蜂计划天梯榜显示的是所有参与蜂计划打卡的各类排行，我的小蜂巢里面内容是用户获得的积分和徽章奖励</div>
    <div class="img">
      <img class="img1" src="../assets/images/intro/pczx15.png?v=20240805" alt="">
    </div>
    <div class="img">
      <img class="img1" src="../assets/images/intro/pczx14.png?v=20240805" alt="">
    </div>
    <div class="img">
      <img class="img1" src="../assets/images/intro/pczx13.png?v=20240805" alt="">
    </div>
    <div class="p">4、创建蜂计划可以选择自己要打卡的词库，选择打卡的数量和显示对应的天数，并可以选择打卡的单词顺序，最终制定好属于自己的打卡计划。</div>
    <div class="img">
      <img class="img1" src="../assets/images/intro/pczx12.png?v=20240805" alt="">
    </div>
    <div class="img">
      <img class="img1" src="../assets/images/intro/pczx11.png?v=20240805" alt="">
    </div>
    <div class="img">
      <img class="img1" src="../assets/images/intro/pczx10.png?v=20240805" alt="">
    </div>
    <div class="img">
      <img class="img1" src="../assets/images/intro/pczx9.png?v=20240805" alt="">
    </div>
    <div class="img">
      <img class="img1" src="../assets/images/intro/pczx8.png?v=20240805" alt="">
    </div>
    <div class="p">5、点击已创建的计划进入计划详情可以查看蜂计划日历，并可以进行学习和打卡练习，打
卡过程中如遇到突发事件可以点击左上角返回按钮，可选择保存当前打卡进度或不保存当前
打卡进度，如过保存打卡进度，当天再次打卡回再次回到当前打卡进度打卡，如选择不保存，
则当天再次打卡会重新开始。</div>
    <div class="img">
      <img class="img1" src="../assets/images/intro/pczx16.png?v=20240805" alt="">
    </div>
    <div class="img">
      <img class="img1" src="../assets/images/intro/pczx17.png?v=20240805" alt="">
    </div>
    <div class="img">
      <img class="img1" src="../assets/images/intro/pczx18.png?v=20240805" alt="">
    </div>
    <div class="img">
      <img class="img1" src="../assets/images/intro/pczx19.png?v=20240805" alt="">
    </div>
    <div class="p">6、打卡结束后会展示打卡结果界面并根据打卡情况给到用户相应的积分内容。点击查看详
      情可以查看本次打卡单词的情况。</div>
    <div class="img">
      <img class="img1" src="../assets/images/intro/pczx21.png?v=20240805" alt="">
    </div>
    <div class="img">
      <img class="img1" src="../assets/images/intro/pczx20.png?v=20240805" alt="">
    </div>
    <div class="p">7、针对已创建的计划可以在计划首页和计划详情进行删除操作</div>
    <div class="img">
      <img class="img1" src="../assets/images/intro/pczx23.png?v=20240805" alt="">
    </div>
    <div class="img">
      <img class="img1" src="../assets/images/intro/pczx22.png?v=20240805" alt="">
    </div>


    <div class="title2">蜂竞技使用说明</div>
    <div class="p">
      App 首页点击蜂竞技，进入游戏大厅，在游戏大厅可以选择某一个游戏进行游戏，游戏分为训练模式和联机模式
      <br/>
      训练模式：仅自己或跟机器人玩
      <br/>
      联机模式：跟真人线上玩
    </div>
    <div class="img">
      <img class="img1" src="../assets/images/intro/pczx26.png?v=20240805" alt="">
    </div>
    <div class="p">进入游戏大厅，可以进行音效设置</div>
    <div class="img">
      <img class="img1" src="../assets/images/intro/pczx25.png?v=20240805" alt="">
    </div>
    <div class="img">
      <img class="img1" src="../assets/images/intro/pczx24.png?v=20240805" alt="">
    </div>
    <div class="p">点击某个游戏，会弹出选择游戏模式的弹框，在此可以选择训练模式或联机模式</div>
    <div class="img">
      <img class="img1" src="../assets/images/intro/pczx27.png?v=20240805" alt="">
    </div>
    <div class="p"><b>1、拼词竞技</b></div>
    <div class="p">训练模式，点击训练模式后会进入创建房间的页面，在此页面用户可以对房间基本信息进行
      设置，并创建游戏进行开玩</div>
    <div class="img">
      <img class="img1" src="../assets/images/intro/pczx29.png?v=20240805" alt="">
    </div>
    <div class="img">
      <img class="img1" src="../assets/images/intro/pczx28.png?v=20240805" alt="">
    </div>
    <div class="p">比如用户创建了一个两人的训练房间，则 test1 为当前用户，选择 1 则为机器人</div>
    <div class="img">
      <img class="img1" src="../assets/images/intro/pczx30.png?v=20240805" alt="">
    </div>
    <div class="p">点击开始后界面会切换为如下的样式，用户可以通过底部的键盘进行答题，答题过程中可以
      对 word，definition，sentence 这几个按钮进行点击，听对应的音频提示</div>
    <div class="img">
      <img class="img1" src="../assets/images/intro/pczx31.png?v=20240805" alt="">
    </div>
    <div class="p">答完所有题后，会弹出如下的弹框，点击弹框中的确定，会进入到此次比赛的排行界面，该
      页面展示所有人的排行信息</div>
    <div class="img">
      <img class="img1" src="../assets/images/intro/pczx33.png?v=20240805" alt="">
    </div>
    <div class="img">
      <img class="img1" src="../assets/images/intro/pczx32.png?v=20240805" alt="">
    </div>
    <div class="p">点击查看答题卡会进入答题详情页面，该页面会展示该用户本次比赛的答题详情记录信息</div>
    <div class="img">
      <img class="img1" src="../assets/images/intro/pczx34.png?v=20240805" alt="">
    </div>
    <div class="p">点击联机模式的话，会进入到房间列表的页面，在此页面，用户可以加入到别人创建的房间
进行比赛，也可以自己创建房间进行比赛，也可以让系统匹配房间进行比赛，以及查看游戏
规则等</div>
    <div class="img">
      <img class="img1" src="../assets/images/intro/pczx36.png?v=20240805" alt="">
    </div>
    <div class="img">
      <img class="img1" src="../assets/images/intro/pczx35.png?v=20240805" alt="">
    </div>
    <div class="p">1、自己创建房间</div>
    <div class="p">创建完房间会显示在房间列表页面，该页面只会显示当前类型的房间，比如该用户当前
      是小学组的用户，那他只能看到小学组的用户创建的房间</div>
    <div class="p">2、选择房间列表里面的房间进行比赛：如果这个房间人数未满，并且未开始，则可以点击
进入房间进行比赛，否则不可以进入游戏房间，房间列表里面仅会显示当前未结束的所有房
间。</div>
    <div class="p">3、匹配房间：用户进入专门的匹配房间的页面，并有 10 秒倒计时，在此期间，如果人数
达到指定的人数，则系统会创建一个房间，将这些人组织到这个房间进行游戏，如果 10 秒
内未达到指定的人数，则系统会将差的人数以机器人代替，创建房间，并进行比赛。</div>
    <div class="img">
      <img class="img1" src="../assets/images/intro/pczx37.png?v=20240805" alt="">
    </div>

    <div class="p"><b>2、极速拼词</b></div>
    <div class="p">训练模式，点击训练模式后会进入创建房间的页面，在此页面用户可以对房间基本信息进行
      设置，并创建游戏进行开玩。</div>
    <div class="img">
      <img class="img1" src="../assets/images/intro/pczx39.png?v=20240805" alt="">
    </div>
    <div class="img">
      <img class="img1" src="../assets/images/intro/pczx38.png?v=20240805" alt="">
    </div>
    <div class="p">创建的房间仅自己一个人即可开玩</div>
    <div class="img">
      <img class="img1" src="../assets/images/intro/pczx40.png?v=20240805" alt="">
    </div>
    <div class="p">点击开始后界面会切换为如下的样式，用户可以通过底部的键盘进行答题，答题过程中可以
      对 word 这个按钮进行点击，听对应的音频提示，可以点击 pass 按钮进行跳过</div>
    <div class="img">
      <img class="img1" src="../assets/images/intro/pczx41.png?v=20240805" alt="">
    </div>
    <div class="p">答完所有题后，会弹出如下的弹框，点击弹框中的确定，会进入到此次比赛的排行界面，该
      页面展示所有人的排行信息</div>
    <div class="img">
      <img class="img1" src="../assets/images/intro/pczx43.png?v=20240805" alt="">
    </div>
    <div class="img">
      <img class="img1" src="../assets/images/intro/pczx42.png?v=20240805" alt="">
    </div>
    <div class="p">点击联机模式的话，会进入到房间列表的页面，在此页面，用户可以加入到别人创建的房间
进行比赛，也可以自己创建房间进行比赛，也可以让系统匹配房间进行比赛，以及查看游戏
规则等</div>
    <div class="img">
      <img class="img1" src="../assets/images/intro/pczx45.png?v=20240805" alt="">
    </div>
    <div class="img">
      <img class="img1" src="../assets/images/intro/pczx44.png?v=20240805" alt="">
    </div>
    <div class="p">1、自己创建房间</div>
    <div class="p">创建完房间会显示在房间列表页面，该页面只会显示当前类型的房间，比如该用户当前
      是小学组的用户，那他只能看到小学组的用户创建的房间</div>
    <div class="p">2、选择房间列表里面的房间进行比赛：如果这个房间人数未满，并且未开始，则可以点击
进入房间进行比赛，否则不可以进入游戏房间，房间列表里面仅会显示当前未结束的所有房
间。</div>
    <div class="p">3、匹配房间：用户进入专门的匹配房间的页面，并有 10 秒倒计时，在此期间，如果人数
达到指定的人数，则系统会创建一个房间，将这些人组织到这个房间进行游戏，如果 10 秒
内未达到指定的人数，则系统会将差的人数以机器人代替，创建房间，并进行比赛。</div>
    <div class="img">
      <img class="img1" src="../assets/images/intro/pczx46.png?v=20240805" alt="">
    </div>
    <div class="p">自己创建的房间，等待别人进入</div>
    <div class="p">房主视角，其他选手进入并准备后，即可点击开始进行游戏</div>
    <div class="img">
      <img class="img1" src="../assets/images/intro/pczx47.png?v=20240805" alt="">
    </div>
    <div class="p">非房主视角</div>
    <div class="img">
      <img class="img1" src="../assets/images/intro/pczx48.png?v=20240805" alt="">
    </div>
    <div class="p">比赛中的画面</div>
    <div class="img">
      <img class="img1" src="../assets/images/intro/pczx49.png?v=20240805" alt="">
    </div>
    <div class="p">答题结束的排行页面</div>
    <div class="img">
      <img class="img1" src="../assets/images/intro/pczx50.png?v=20240805" alt="">
    </div>
    <!-- <div class="img">
      <img class="img1" src="../assets/images/intro/pczx37.png?v=20240805" alt="">
    </div> -->

    <div class="p"><b>3、字母接龙</b></div>
    <div class="p">目前仅提供联机模式</div>
    <div class="p">联机模式的话，会进入到房间列表的页面，在此页面，用户可以加入到别人创建的房间进行
比赛，也可以自己创建房间进行比赛，也可以让系统匹配房间进行比赛，以及查看游戏规则
等</div>
    <div class="img">
      <img class="img1" src="../assets/images/intro/pczx52.png?v=20240805" alt="">
    </div>
    <div class="img">
      <img class="img1" src="../assets/images/intro/pczx51.png?v=20240805" alt="">
    </div>
    <div class="p">1、自己创建房间</div>
    <div class="p">创建完房间会显示在房间列表页面，该页面只会显示当前类型的房间，比如该用户当前
      是小学组的用户，那他只能看到小学组的用户创建的房间</div>
    <div class="p">2、选择房间列表里面的房间进行比赛：如果这个房间人数未满，并且未开始，则可以点击
进入房间进行比赛，否则不可以进入游戏房间，房间列表里面仅会显示当前未结束的所有房
间。</div>
    <div class="p">3、匹配房间：用户进入专门的匹配房间的页面，并有 10 秒倒计时，在此期间，如果人数
达到指定的人数，则系统会创建一个房间，将这些人组织到这个房间进行游戏，如果 10 秒
内未达到指定的人数，则系统会将差的人数以机器人代替，创建房间，并进行比赛。</div>
    <div class="img">
      <img class="img1" src="../assets/images/intro/pczx53.png?v=20240805" alt="">
    </div>
    <div class="p">自己创建的房间，等待别人进入</div>
    <div class="p">房主视角，其他选手进入并准备后，即可点击开始进行游戏</div>
    <div class="img">
      <img class="img1" src="../assets/images/intro/pczx55.png?v=20240805" alt="">
    </div>
    <div class="img">
      <img class="img1" src="../assets/images/intro/pczx54.png?v=20240805" alt="">
    </div>
    <div class="p">答题视角</div>
    <div class="img">
      <img class="img1" src="../assets/images/intro/pczx56.png?v=20240805" alt="">
    </div>
    <div class="p">等待答题视角</div>
    <div class="img">
      <img class="img1" src="../assets/images/intro/pczx57.png?v=20240805" alt="">
    </div>
    <div class="p">答完所有单词后，弹出完成的弹框</div>
    <div class="img">
      <img class="img1" src="../assets/images/intro/pczx58.png?v=20240805" alt="">
    </div>
    <div class="p">点击确定后，跳转到排行页面，该页面展示了用户的详细答题信息</div>
    <div class="img">
      <img class="img1" src="../assets/images/intro/pczx59.png?v=20240805" alt="">
    </div>



  </div>
</template>
<script>
export default {
  data () {
    return {
    }
  },
  created () {
    // 防止第一版部署的二维码有缓存，如果直接打开980，先跳转回菜单页
    if (!this.$route.query.id) {
      this.$router.push('/introMenu')
    }
  }
}
</script>
<style lang="less" scoped>
.page{
  position: relative;
  height: 100vh;
  background: linear-gradient(to right, #373634, #191409);
  color: #fff;
  overflow-x: hidden;
  overflow-y: auto;
}
.video{
  width: 100%;
  height: 100vh;
  background-color: #000;
}
.title{
  padding: 40px 20px 20px;
  font-size: 24px;
  font-weight: 900;
  // font-family: hzgb;
  // &::after{
  //   display: block;
  //   content: '';
  //   width: 100px;
  //   height: 3px;
  //   background-color: #ffd52f;
  //   margin-top: 6px;
  // }
}
.title2{
  font-size: 18px;
  font-weight: bold;
  padding: 10px 20px;
  text-indent: 2em;
}
.p{
  font-size: 16px;
  padding: 0 20px;
  margin-bottom: 10px;
  text-indent: 2em;
}
.p1{
  text-indent: 0;
}
.img{
  text-align: center;
  padding: 10px 0;
  img{
    width: 80%;
    height: auto;
  }
  .img1{
    height: auto;
    width: 60%;
    border: 6px solid #ffd52f;
    border-radius: 6px;
  }
}
</style>